import React, { useEffect } from "react";
import Drawer from "../../../drawer/Drawer";
import TicketInfo from "./TicketInfo";
import Ticket from "./Ticket";
import { t } from "i18next";

const TicketOrderDetailsDrawer = ({
  open,
  setOpen = () => {},
  navigate = () => {},
  location,
  orderData,
  orderId,
}) => {
  return (
    <Drawer
      open={open}
      onClose={() => {
        setOpen(false);
        navigate(location?.pathname);
      }}
      actualSize="xl6"
      size="xl6"
      openFrom="right"
      title={
        <span className="tracking-tighter uppercase font-bold">
          {t("Order details")}
        </span>
      }
      subtitle={t("View order details and information bellow")}
      drawerBodyClass="p-0 max-h-[calc(100%-85px)] overflow-y-visible scrollbar flex bg-gradient-to-tr from-[#f5faff] via-white to-[#fef6f9]"
    >
      <div className="grid grid-cols-12 gap-6 w-full mx-auto px-6 py-4 items-start bg-gradient-to-br from-white to-slate-50 rounded-2xl shadow-sm overflow-y-auto">
        <div className="col-span-12 lg:col-span-4 2xl:col-span-5 lg:sticky lg:top-0">
          <TicketInfo
            orderData={{
              ...orderData?.data,
              eventId: orderData?.data?.eventData?.uid,
            }}
          />
        </div>

        <div className="col-span-12 lg:col-span-8 2xl:col-span-7 pr-2 scrollbar space-y-7 pt-4">
          {orderData?.data?.orderItemData?.map((ticket, i) => (
            <Ticket
              key={i?.toString()}
              ticket={ticket}
              orderData={{
                ...orderData?.data,
                eventId: orderData?.data?.eventData?.uid,
              }}
              eventData={orderData?.data?.eventData}
            />
          ))}
        </div>
      </div>
    </Drawer>
  );
};

export default TicketOrderDetailsDrawer;
